import type { jobResource } from '@porotutu/api/features/crm/jobs/resource'
import { unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { JOBS } from '@/api/keys'
import type { JobKind, JobSort, JobState } from '../vocabulary'

export type Job = ReturnType<typeof jobResource>

export type JobPage = { data: Job[]; meta: ListMeta; tallies: Record<string, number> }

export type JobListQuery = ListQuery<JobSort, never> & { kind?: JobKind; state?: JobState }

export const jobsQuery = (query: JobListQuery) =>
  queryOptions({
    queryKey: [...JOBS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.jobs.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 5_000,
  })

export const jobQuery = (id: string) =>
  queryOptions({
    queryKey: [...JOBS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.jobs({ id }).get()),
    staleTime: 5_000,
  })
